"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _noResults = _interopRequireDefault(require("../../assets/images/no-results.png"));

var _NoResults = require("./NoResults.styles");

var NoResults = function NoResults(_ref) {
  var img = _ref.img,
      className = _ref.className,
      title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      imgBoxStyles = _ref.imgBoxStyles,
      hasBorder = _ref.hasBorder;
  return (0, _jsxRuntime.jsxs)("div", {
    css: [_NoResults.styles.base, hasBorder && _NoResults.styles.withBorder, process.env.NODE_ENV === "production" ? "" : ";label:NoResults;"],
    className: className,
    children: [(0, _jsxRuntime.jsx)("div", {
      className: "grui my-10",
      css: [_NoResults.styles.imgBox, imgBoxStyles, process.env.NODE_ENV === "production" ? "" : ";label:NoResults;"],
      children: img && (0, _jsxRuntime.jsx)("img", {
        src: img,
        alt: title
      })
    }), (0, _jsxRuntime.jsx)("h3", {
      css: _elements.heading.styles.h3,
      children: title
    }), (0, _jsxRuntime.jsx)("p", {
      className: "grui mt-5 mb-11",
      css: [_elements.paragraph.styles.preflight, _NoResults.styles.subtitle, process.env.NODE_ENV === "production" ? "" : ";label:NoResults;"],
      children: subtitle
    }), children]
  });
};

NoResults.propTypes = {
  className: _propTypes.string,
  img: _propTypes.string,
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  subtitle: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  imgBoxStyles: (0, _propTypes.shape)({
    styles: _propTypes.string
  }),
  hasBorder: _propTypes.bool
};
NoResults.defaultProps = {
  className: undefined,

  /**
   * If no img, will show default img
   */
  img: _noResults["default"],
  title: undefined,
  subtitle: undefined,
  children: undefined,
  imgBoxStyles: undefined,
  hasBorder: false
};
var _default = NoResults;
exports["default"] = _default;
//# sourceMappingURL=NoResults.js.map